import { useEffect } from "react";

import Helpers from "../../commons/helpers";

import { useCommentContext } from "../../providers/CommentProvider";
import { IDataComment, IReaction, IUserReaction } from "../../commons/interfaces";
import ReactionCoppy from "./reactionCopy";



const _ = require("lodash");

interface IProps {
    item: IDataComment;
    hiddenAction: boolean;
    hiddenActionRetry: boolean;
    reactionIcon: IReaction[];
    unReaction: (id: string) => void;
    handleSetIdShowInputComment: (id: string) => void;
    handleSetDataReplyComment: (data: IDataComment) => void;
    reaction: (targetId: string, reactionCode: number) => void;
}

let buttonMouseIn: any = undefined;
let buttonMouseOut: any = undefined;

const ActionBox = ({
    item,
    hiddenAction,
    hiddenActionRetry,
    reactionIcon,
    unReaction,
    reaction,
    handleSetIdShowInputComment,
    handleSetDataReplyComment,
}: IProps) => {
    // action
    const { userLogin } = useCommentContext();

    const myReaction = (item.userReactions || [])?.find((child: IUserReaction) => child.userId === userLogin?.userId);

    let liked = !Helpers.isNullOrEmpty(myReaction);

    const handleReply = (item: any) => {
        handleSetIdShowInputComment(`${item.id}`);
        handleSetDataReplyComment({
            userComment: userLogin,
            id: item.id,
            // message: `@${item?.userComment?.fullName} `,
        });
    };

    const handleReaction = (targetId: string, reactionCode: number) => {
        if (liked) {
            handleUnReaction(myReaction?.id || "");
        }
        reaction && reaction(targetId, reactionCode);

        hideActionBox();
    };

    const debounceReaction = _.debounce(async (itemId: string, reactionCode: number) => {
        await handleReaction(itemId, reactionCode);
    }, 200);

    const debounceUnReaction = _.debounce(async (itemId: string) => {
        await handleUnReaction(itemId);
    }, 200);

    const handleUnReaction = (id: string) => {
        unReaction && unReaction(id);
        liked = false;
        hideActionBox();
    };

    const hideActionBox = () => {
        const reactionBox = document.getElementById(`reaction${item.id}`)!;

        reactionBox.classList.add("cr-hidden");
        reactionBox.classList.remove("cr-show");
    };

    useEffect(() => {
        if (!hiddenAction) {
            const containers = document.getElementById(`like${item.id}`)!;
            const reactionBox = document.getElementById(`reaction${item.id}`)!;

            containers.addEventListener("mouseenter", () => {
                buttonMouseIn = setTimeout(() => {
                    reactionBox.classList.remove("cr-hidden");
                    reactionBox.classList.add("cr-show");
                }, 200);
            });

            containers.addEventListener("mouseout", () => {
                if (buttonMouseIn) {
                    clearTimeout(buttonMouseIn);
                }
                buttonMouseOut = setTimeout(() => {
                    reactionBox.classList.add("cr-hidden");
                    reactionBox.classList.remove("cr-show");
                }, 200);
            });

            reactionBox.addEventListener("mouseenter", () => {
                if (buttonMouseOut) {
                    clearTimeout(buttonMouseOut);
                }
            });

            reactionBox.addEventListener("mouseleave", () => {
                setTimeout(() => {
                    reactionBox.classList.add("cr-hidden");
                    reactionBox.classList.remove("cr-show");
                }, 200);
            });
        }
    }, []);

    return !hiddenAction
        ? (
            <div className="cr-action-box">
                <button
                    id={`like${item.id}`}
                    className={`cr-action-button ${liked && "cr-text-primary"}`}
                    onClick={() => {
                        liked ? debounceUnReaction(myReaction?.id) : debounceReaction(item.id || "", reactionIcon?.[0].reactionCode);
                    }}
                >
                    {liked ? "Bỏ thích" : "Thích"}
                </button>
                <div id={`reaction${item.id}`} className="cr-reaction-box cr-hidden">
                    {(reactionIcon || []).map((icon, index) => (
                        <div
                            key={index}
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={() => {
                                const myReaction = item.userReactions?.find(
                                    (child: IUserReaction) => child.userId === userLogin?.userId && Number(child.reactionCode) === icon.reactionCode
                                );
                                liked = !Helpers.isNullOrEmpty(myReaction);
                                liked ? debounceUnReaction(myReaction?.id) : debounceReaction(item.id || "", icon.reactionCode);
                            }}
                        >
                            <img key={index} alt="" src={`data:image/svg+xml;base64,${icon.emojiBase64}`} />
                        </div>
                    ))}
                </div>
                {
                    <button
                        className="cr-action-button"
                        onClick={() => handleReply(item)}
                        style={{ visibility: hiddenActionRetry ? "hidden" : "visible" }}
                    >
                        Trả lời
                    </button>
                }
                <ReactionCoppy userReactions={item.userReactions || []} reactionIcon={reactionIcon || []} />
            </div>
        )
        : <></>;
};

export default ActionBox;
